// extracted by mini-css-extract-plugin
module.exports = {"background":"Login_background__2yI12"};